export const ORIGIN_SOURCE_DATASETS = [
  { label: 'External', pattern: 'horizontal', key: 'external' },
  { label: 'Manual', pattern: 'diagonal-right', key: 'manual' },
  { label: 'Autobook', pattern: 'diagonal-left', key: 'autobook' },
];

export const TERMINAL_DATASETS = [
  { label: 'Trapac', pattern: 'diagonal-right', key: 'trapac' },
  { label: 'Matson', pattern: 'horizontal', key: 'matson' },
  { label: 'SSA Marine', pattern: 'diagonal-left', key: 'ssaMarine' },
  { label: 'Everport', pattern: 'vertical', key: 'everport' },
  { label: 'Yusen', pattern: 'cross', key: 'yusen' },
];

export const STATUS_DATASETS = [
  { label: 'Rejected', pattern: 'diagonal-left', key: 'rejected' },
  { label: 'Used', pattern: 'diagonal-left', key: 'used' },
  { label: 'Canceled', pattern: 'vertical', key: 'cancelled' },
  { label: 'Expired', pattern: 'horizontal', key: 'expired' },
  { label: 'Rescheduled', pattern: 'cross', key: 'rescheduled' },
  { label: 'Scheduled', pattern: 'diagonal-right', key: 'scheduled' },
];

// Legend items configuration (same as datasets but for legend display)
export const ORIGIN_SOURCE_LEGEND_ITEMS = ORIGIN_SOURCE_DATASETS.map(
  ({ label, pattern }) => ({
    label,
    pattern,
  })
);

export const TERMINAL_LEGEND_ITEMS = TERMINAL_DATASETS.map(
  ({ label, pattern }) => ({
    label,
    pattern,
  })
);

export const STATUS_LEGEND_ITEMS = STATUS_DATASETS.map(
  ({ label, pattern }) => ({
    label,
    pattern,
  })
);

/** Redelivery chart metrics — keys match API `chartData[].data`. */
export const REDELIVERY_METRIC_DATASETS = [
  {
    label: 'Live Unload Redelivery',
    pattern: 'diagonal-right',
    key: 'liveRedelivery',
  },
  {
    label: 'Drop & Pick Redelivery',
    pattern: 'horizontal',
    key: 'dropRedelivery',
  },
  { label: 'Live Unload Direct', pattern: 'diagonal-left', key: 'liveDirect' },
  { label: 'Drop & Pick Direct', pattern: 'vertical', key: 'dropDirect' },
];

export const pickDefaultRedeliveryMetricKey = (dayItem) => {
  const metrics = dayItem?.data || {};
  let bestKey = REDELIVERY_METRIC_DATASETS[0].key;
  let bestVal = -1;

  REDELIVERY_METRIC_DATASETS.forEach(({ key }) => {
    const value = Number(metrics[key]) || 0;
    if (value > bestVal) {
      bestVal = value;
      bestKey = key;
    }
  });

  return bestKey;
};
